function iniSwiper(selector) {
  var swiper = new Swiper(selector, {
    slidesPerView: "auto",
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
}

$(document).on('click','.product-add-to-cart-btn',function(){ 
  var ID = $(this).attr("data-id"); 
  $(this).addClass('btn--loading')
  $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  data: {
    quantity: 1,
    id: ID
  },
  dataType: 'json', 
 success: function (data) { 
   $('.product-add-to-cart-btn').removeClass('btn--loading');
  document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
 } 
 });
}) 

class CartRecommend extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.productId = this.dataset.productId;
    this.sectionId = document.querySelector('.shopify-section-group-header-group').id.replace("shopify-section-", '');
    this.url = `/recommendations/products?section_id=${this.sectionId}&product_id=${this.productId}&limit=6`;
    this.intent = this.dataset.intent;
    this.placeholder = this.querySelector('.product-recommendations-placeholder');
  }

  connectedCallback(){
    fetch(this.url)
    .then(response => response.text())
    .then(text => {

    const html = document.createElement('div');
    html.innerHTML = text;
    const recommendations = html.querySelector('.product_recommendation_main');

    this.placeholder.innerHTML = '';
    this.placeholder.innerHTML = recommendations.innerHTML;

    iniSwiper(".cartSwiper");

    })
    .catch(e => {
      console.error(e);
    });
  }

}


customElements.define('cart-recommend', CartRecommend);